import type { WithdrawalCode } from './types';

const WITHDRAWAL_CODES = new Set<string>([
  'OK',
  'SUBMITTED',
  'LOGIN_REQUIRED',
  'NO_MATCH',
  'ACCESS_DENIED',
  'WINDOW_EXPIRED',
  'DUPLICATE_REQUEST',
  'VALIDATION_ERROR',
]);

const API_CODE_ALIASES: Record<string, WithdrawalCode> = {
  'withdrawal.login_required': 'LOGIN_REQUIRED',
};

export function normalizeWithdrawalCode(
  code: string | null | undefined,
): WithdrawalCode | null {
  if (!code) {
    return null;
  }

  const alias = API_CODE_ALIASES[code];
  if (alias) {
    return alias;
  }

  if (WITHDRAWAL_CODES.has(code)) {
    return code as WithdrawalCode;
  }

  return 'VALIDATION_ERROR';
}
